import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');

export function getAllIssues(env, page) {
    return (dispatch, getState) => {
        const assigneeIds = getState().environments[env].gitlabApi.get('assigneeIds');
        const groupId = getState().environments[env].gitlabApi.get('groupId');
        return apiCaller
            .call(api.getAllIssues(env, page, assigneeIds, groupId))
            .then(({ data, response }) => {
                if (response.status === 200) {
                    const pages = {
                        current: parseInt(response.headers.get('x-page')),
                        total: parseInt(response.headers.get('x-total-pages')),
                        next: parseInt(response.headers.get('x-next-page')),
                    };

                    let issues = {};
                    data.forEach(({ id, iid, title, project_id, created_at, state, labels }) => {
                        issues[id] = { iid, title, project_id, created_at, state, labels };
                    });
                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_ISSUES`,
                        issues,
                        currentPage: pages.current,
                        nextPage: pages.next,
                        totalPages: pages.total,
                    });
                    return pages;
                } else throw new Error('issues_have_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getAllIssues - ', error);
                throw error;
            });
    };
}
export function getIssue(env, projectID, issueId) {
    return dispatch => {
        return apiCaller
            .call(api.getIssue(env, projectID, issueId))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url, labels } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author, labels } };
                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_ISSUE`,
                        issue,
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getIssue - ', error);
                throw error;
            });
    };
}
export function updateIssue(env, projectID, issueId, formIssue) {
    return dispatch => {
        return apiCaller
            .call(api.updateIssue(env, projectID, issueId, formIssue))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url, labels } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author, labels } };

                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_ISSUE`,
                        issue,
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: updateIssue - ', error);
                throw error;
            });
    };
}
export function createIssue(env, formIssue) {
    return (dispatch, getState) => {
        const assigneeIds = getState().environments[env].gitlabApi.get('assigneeIds');
        formIssue.project_id = getState().environments[env].gitlabApi.get('groupId');
        return apiCaller
            .call(api.createIssue(env, formIssue, assigneeIds))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url, labels } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author, labels } };

                    dispatch({
                        type: `${env.toUpperCase()}_GIT__SET_ISSUE`,
                        issue,
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: createIssue - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Issues/actions.js